import {
  AppsContainer,
  AppResponsiveTabs,
} from "@lib/components/AppComponents";
import type { AppTabProps } from "@lib/components/AppComponents/AppTabs";
import { useDateRange } from "@lib/hooks/useDateRange";
import { Dayjs } from "dayjs";
import { useCallback, useMemo, useState } from "react";
import { useIntl } from "react-intl";
import { useSearchParams } from "react-router-dom";
import useScreen from "@lib/hooks/useScreen";
import ManagementInvoices from "./Invoices";
import ManagementSendbyte from "./Sendbyte";
import ManagementAIPayments from "./AIPayments";
import ManagementPaymentProvider from "./PaymentProvider";
import ManagementTftSales from "./TftSales";

export default function AdminManagementDashboard() {
  const { messages } = useIntl();
  const { isMobile } = useScreen();
  const [searchParams, setSearchParams] = useSearchParams();
  const { dateBetween, setDateBetween } = useDateRange({
    initialRange: "monthly",
  });

  const handleDateBetween = useCallback((date: [Dayjs, Dayjs]) => {
    setDateBetween(date);
  }, []);

  const tabs: AppTabProps[] = useMemo(
    () => [
      {
        key: "customerBillings",
        Title: messages["common.customerBillings"] as string,
        Component: ManagementInvoices,
        props: {
          dateBetween,
        },
      },
      {
        key: "aiPayments",
        Title: messages["common.aiPayments"] as string,
        Component: ManagementAIPayments,
        props: {
          dateBetween,
        },
      },
      {
        key: "leadPayments",
        Title: messages["common.leadPayments"] as string,
        Component: ManagementSendbyte,
        props: {
          dateBetween,
        },
      },
      {
        key: "providerPayments",
        Title: messages["common.providerPayments"] as string,
        Component: ManagementPaymentProvider,
        props: {
          dateBetween,
        },
      },
      {
        key: "tftSales",
        Title: messages["sidebar.dashboard.tftSales"] as string,
        Component: ManagementTftSales,
        props: {
          dateBetween,
        },
      },
    ],
    [dateBetween],
  );
  const [selectedTab, setSelectedTab] = useState<string>(
    searchParams.get("tab") || tabs[0].key,
  );

  const handleChangeTab = (tab: string) => {
    setSelectedTab(tab);
    setSearchParams({ tab });
  };

  return (
    <AppsContainer
      title={messages["common.dashboard"] as string}
      fullView
      cardStyle={{
        background: "transparent",
        boxShadow: "none",
      }}
      showBreadcrumb={!isMobile}
      showDateRange={true}
      dateRangeValue={dateBetween}
      onDateRangeChange={handleDateBetween}
    >
      <AppResponsiveTabs
        tabs={tabs}
        selectedTab={selectedTab}
        onChange={handleChangeTab}
      />
    </AppsContainer>
  );
}
